import React, { useState, useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./Resume.css";

const Resume = (props) => {
  /* STATES */
  const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
  const [carousalOffsetStyle, setCarousalOffsetStyle] = useState({});

  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  /* REUSABLE MINOR COMPONENTS */
  const ResumeHeading = (props) => {
    return (
      <div className="resume-heading">
        <div className="resume-main-heading">
          <div className="heading-bullet"></div>
          <span>{props.heading ? props.heading : ""}</span>
          {props.fromDate && props.toDate ? (
            <div className="heading-date">
              {props.fromDate + "-" + props.toDate}
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div className="resume-sub-heading">
          <span>{props.subHeading ? props.subHeading : ""}</span>
        </div>
        <div className="resume-heading-description">
          <span>{props.description ? props.description : ""}</span>
        </div>
      </div>
    );
  };

  /* STATIC RESUME DATA FOR THE LABELS*/
  const resumeBullets = [
    { label: "Front End", logoSrc: "programming-skills.svg" },
    { label: "Back End", logoSrc: "programming-skills.svg" },
    // { label: "Work History", logoSrc: "work-history.svg" },

    // { label: "Projects", logoSrc: "projects.svg" },
    { label: "Database", logoSrc: "programming-skills.svg" },
    { label: "Languages", logoSrc: "programming-skills.svg" },
    { label: "Tools & Technology", logoSrc: "programming-skills.svg" },
  ];

  //here we have
  const programmingSkillsDetails = [
    { skill: "Express JS", ratingPercentage: 80 },
    { skill: "Node JS", ratingPercentage: 70 },
    { skill: "Mongo DB", ratingPercentage: 85 },
    // { skill: "Core Java", ratingPercentage: 80 },
    { skill: "HTML", ratingPercentage: 80 },
    { skill: "CSS", ratingPercentage: 80 },
  ];

  const frontEndSkills = [
    {
      skill: "HTML",
      logoURL:
        "https://profilinator.rishav.dev/skills-assets/html5-original-wordmark.svg",
    },
    {
      skill: "CSS",
      logoURL:
        "https://profilinator.rishav.dev/skills-assets/css3-original-wordmark.svg",
    },
    {
      skill: "React JS",
      logoURL:
        "https://profilinator.rishav.dev/skills-assets/react-original-wordmark.svg",
    },
    {
      skill: "Redux",
      logoURL:
        "https://profilinator.rishav.dev/skills-assets/redux-original.svg",
    },
    {
      skill: "Chakra",
      logoURL:
        "https://pbs.twimg.com/profile_images/1244925541448286208/rzylUjaf_400x400.jpg",
    },
  ];

  const backEndSkills = [
    {
      skill: "Node JS",
      logoURL:
        "https://profilinator.rishav.dev/skills-assets/nodejs-original-wordmark.svg",
    },
    {
      skill: "Express JS",
      logoURL:
        "https://profilinator.rishav.dev/skills-assets/express-original-wordmark.svg",
    },
  ];

  const databaseSkills = [
    {
      skill: "MongoDB",
      logoURL:
        "https://profilinator.rishav.dev/skills-assets/mongodb-original-wordmark.svg",
    },
    {
      skill: "MySQL",
      logoURL:
        "https://profilinator.rishav.dev/skills-assets/mysql-original-wordmark.svg",
    },
  ];

  const languageSkills = [
    {
      skill: "JavaScript",
      logoURL:
        "https://profilinator.rishav.dev/skills-assets/javascript-original.svg",
    },
    {
      skill: "Java",
      logoURL:
        "https://profilinator.rishav.dev/skills-assets/java-original-wordmark.svg",
    },
  ];

  const toolsSkills = [
    {
      skill: "Git",
      logoURL: "https://profilinator.rishav.dev/skills-assets/git-scm-icon.svg",
    },
    {
      skill: "Postman",
      logoURL:
        "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
    },
    {
      skill: "GitHub",
      logoURL: "https://img.icons8.com/fluency/96/000000/github.png",
    },
  ];

  const resumeDetails = [
    /* PROGRAMMING SKILLS */
    <div
      className="resume-screen-container programming-skills-container"
      key="programming-skills1"
    >
      {frontEndSkills.map((skill, index) => (
        <div className="skill-parent" key={index}>
          <span>{skill.skill}</span>

          <div className="skill-icon">
            <img src={skill.logoURL} alt="HTML5" />
          </div>
        </div>
      ))}
    </div>,

    <div
      className="resume-screen-container programming-skills-container"
      key="programming-skills2"
    >
      {backEndSkills.map((skill, index) => (
        <div className="skill-parent" key={index}>
          {/* <div className="heading-bullet"></div> */}
          <span>{skill.skill}</span>
          <div className="skill-icon">
            <img src={skill.logoURL} alt="HTML5" />
          </div>
        </div>
      ))}
    </div>,

    <div
      className="resume-screen-container programming-skills-container"
      key="programming-skills3"
    >
      {databaseSkills.map((skill, index) => (
        <div className="skill-parent" key={index}>
          {/* <div className="heading-bullet"></div> */}
          <span>{skill.skill}</span>
          <div className="skill-icon">
            <img src={skill.logoURL} alt="HTML5" />
          </div>
        </div>
      ))}
    </div>,

    <div
      className="resume-screen-container programming-skills-container"
      key="programming-skills4"
    >
      {languageSkills.map((skill, index) => (
        <div className="skill-parent" key={index}>
          {/* <div className="heading-bullet"></div> */}
          <span>{skill.skill}</span>
          <div className="skill-icon">
            <img src={skill.logoURL} alt="HTML5" />
          </div>
        </div>
      ))}
    </div>,

    <div
      className="resume-screen-container programming-skills-container"
      key="programming-skills4"
    >
      {toolsSkills.map((skill, index) => (
        <div className="skill-parent" key={index}>
          {/* <div className="heading-bullet"></div> */}
          <span>{skill.skill}</span>
          <div className="skill-icon">
            <img src={skill.logoURL} alt="HTML5" />
          </div>
        </div>
      ))}
    </div>,
  ];

  const handleCarousal = (index) => {
    let offsetHeight = 360;

    let newCarousalOffset = {
      style: { transform: "translateY(" + index * offsetHeight * -1 + "px)" },
    };

    setCarousalOffsetStyle(newCarousalOffset);
    setSelectedBulletIndex(index);
  };

  const getBullets = () => {
    return resumeBullets.map((bullet, index) => (
      <div
        onClick={() => handleCarousal(index)}
        className={
          index === selectedBulletIndex ? "bullet selected-bullet" : "bullet"
        }
        key={index}
      >
        <img
          className="bullet-logo"
          src={require(`../../assets/Resume/${bullet.logoSrc}`).default}
          alt="B"
        />
        <span className="bullet-label">{bullet.label}</span>
      </div>
    ));
  };

  const getResumeScreens = () => {
    return (
      <div
        style={carousalOffsetStyle.style}
        className="resume-details-carousal"
      >
        {resumeDetails.map((ResumeDetail) => ResumeDetail)}
      </div>
    );
  };

  useEffect(() => {
    return () => {
      /* UNSUBSCRIBE THE SUBSCRIPTIONS */
      fadeInSubscription.unsubscribe();
    };
  }, [fadeInSubscription]);

  return (
    <div
      className="resume-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="resume-content">
        <ScreenHeading title={"Skills"} subHeading={"Overview of My Skill"} />
        <div className="resume-card">
          <div className="resume-bullets">
            <div className="bullet-container">
              <div className="bullet-icons"></div>
              <div className="bullets">{getBullets()}</div>
            </div>
          </div>

          <div className="resume-bullet-details">{getResumeScreens()}</div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
